import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {DetailService} from "../../../../services/details/detail.service";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../services/helperService";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from '@angular/router';
import {Field} from "../../models/field.model";
import {AuthService} from "../../../../services";

@Component({
	selector: 'tig-form-newslettercontents',
	templateUrl: './form-newslettercontents.component.html',
	styleUrls: ['./form-newslettercontents.component.scss']
})
export class FormNewslettercontentsComponent extends Field implements OnInit {

	public static IFRAME_ID = 'iframe-newlettercontents';


	/**
	 * Attributes
	 */
		// Referenz auf den iFrame
	@ViewChild('OBJ_model_iframe', {static:false}) OBJ_model_iframe;
	public OBJ_iframe_content: SafeHtml = "<div>Loading...</div>";
	private OBJ_iframe_ref: BsModalRef;
	STR_route_to_self ="";
	private STR_id = "";
	private OBJ_newsletter;
	private STR_route_menu: any;
	private STR_route_sub_menu: any;

	/**
	 * @param {Ng4LoadingSpinnerService} OBJ_spinner_service
	 * @param OBJ_detail_service
	 * @param OBJ_sanitizer
	 * @param OBJ_toastr_service
	 * @param OBJ_modal_service
	 * @param OBJ_helper_service
	 * @param OBJ_translate_service
	 * @param OBJ_route
	 * @param OBJ_auth_service
	 */
	constructor(
		private OBJ_spinner_service: Ng4LoadingSpinnerService,
		private OBJ_detail_service: DetailService,
		private OBJ_sanitizer: DomSanitizer,
		private OBJ_toastr_service: ToastrService,
		private OBJ_modal_service: BsModalService,
		private OBJ_helper_service: HelperService,
		private OBJ_translate_service: TranslateService,
		private OBJ_route: ActivatedRoute,
		private OBJ_router: Router,
		private OBJ_auth_service: AuthService
	)
	{
		super();
	} // end constructor

	private isSaving = false;
	ngOnInit(): void
	{
		this.STR_id = this.OBJ_route.snapshot.paramMap.get('id');
		if(this.STR_id !== "new")
		{
			this.STR_route_to_self = '/newsletters/' + this.STR_id;
		} // end if

		this.OBJ_route.parent.params.subscribe(
			params =>
			{
				this.STR_route_menu = params["route_menu"];
			}
		);
		this.OBJ_route.params.subscribe(
			params =>
			{
				this.STR_route_sub_menu = params["route_submenu"];
			}
		)

		this.OBJ_newsletter = this.OBJ_detail_service.OBJ_detail_content.data;
	}


	/**
	 * Function > onMessage
	 * @desc Listen to messages from iframe
	 *
	 * @param event
	 */
	@HostListener('window:message', ['$event'])
	onMessage(event)
	{
		this.receiveMessageFromIFrame(event);
	} // end function onMessage



	/**
	 * Function > closeEditorWithoutSaving
	 */
	closeIFrameWithoutSaving() {
		this.OBJ_detail_service.clearForm();
		this.getFormControl().markAsUntouched();
		this.getFormControl().markAsPristine();
		window.location.reload();
		this.OBJ_iframe_ref.hide();

	}


	/**
	 * Function > openIFrame
	 */
	openIFrame(OBJ_btn: HTMLElement)
	{
		// disable button and show the spinner
		OBJ_btn.setAttribute('disabled', 'disabled');
		this.OBJ_spinner_service.show();

		this.OBJ_detail_service.getIFrame(this.OBJ_field_config._links.iframe.href).subscribe(
			OBJ_response => {

			},
			OBJ_error => {
				this.OBJ_toastr_service.error("Formbuilder could not be loaded");
			},
			() => {
				let OB_modal_options = new ModalOptions();
				OB_modal_options.ignoreBackdropClick = true;
				OB_modal_options.class ='tig-modal-formbuilder';

				// Zeige Modal an
				this.OBJ_iframe_ref = this.OBJ_modal_service.show(this.OBJ_model_iframe, OB_modal_options);
				OBJ_btn.removeAttribute('disabled');
				// hide spinner
				this.OBJ_spinner_service.hide();
			});

	} // end function openIFrame


	/**
	 * Function > receiveMessageFromIFrame
	 *
	 * @desc reagiere auf postmessage des iFrames
	 * @param event
	 */
	receiveMessageFromIFrame(event)
	{

		try
		{

			// try to parse the event we got
			let OBJ_data = event.data;
			switch (OBJ_data.event)
			{
				case 'ready':

					// post message to iFrame
					let OBJ_msg =
						{
							"event": "config",
							"id": this.STR_id,
							"newsletter": this.OBJ_newsletter,
							"contents":this.OBJ_newsletter.placedcontents_edited?this.OBJ_newsletter.placedcontents_edited:[],
							"application": this.OBJ_helper_service.getFromLocalstorage('client').id,
							"network":this.OBJ_helper_service.getFromLocalstorage('client').network,
							"access_token": this.OBJ_helper_service.getFromLocalstorage('access').access_token,
							"refresh_token": this.OBJ_helper_service.getFromLocalstorage('access').refresh_token
						};

					// Post data to iFrame
					event.source.postMessage(OBJ_msg, "*");

					break;

				case 'config':
					if(OBJ_data.errors && OBJ_data.errors.length > 0)
					{

						let STR_error_message = this.OBJ_translate_service.instant("oFormbuilder.sError");

						for (let OBJ_error of OBJ_data.errors)
						{
							STR_error_message += " " + OBJ_error.message + ",";
						} // end for

						// Remove trailing comma
						STR_error_message.substr(0, STR_error_message.length - 1);
						this.OBJ_toastr_service.error(STR_error_message);
					}
					else
					{
						// activecontents nach placedcontents_edited zwischenspeichern
						this.OBJ_newsletter.placedcontents_edited = OBJ_data.data.activecontents
						if(!this.isSaving) {
							this.save(this.OBJ_newsletter);
						}
						//nicht beenden
				//		this.OBJ_iframe_ref.hide();

						this.markAsDirtyAndTouched();
					} // end if
					break;
				case 'generate_hash':
					let OBJ_hash = this.OBJ_helper_service.generateHash(OBJ_data.params, OBJ_data.body, this.OBJ_auth_service.getToken("access_token"));
					// Post data to iFrame
					event.source.postMessage(OBJ_hash, event.origin);
					break;

			} // end switch

		}
		catch (e) {
			// Not the event we are looking for, no need to take action
		} // end try/catch

	} // end function receiveMessageFromIFrame

	public saveNewsletterSuccess()
	{
		let iframeEl = document.getElementById(FormNewslettercontentsComponent.IFRAME_ID) as HTMLIFrameElement;
		let OBJ_msg =
			{
				"event": "save_finish",
				"config": this.OBJ_newsletter
			};
	//	this.OBJ_model_iframe.nativeElement.contentWindow.postMessage(OBJ_msg,"*")

		//this.OBJ_model_iframe.nativeElement.contentWindow.postMessage(OBJ_msg,"*")
		iframeEl.contentWindow.postMessage(OBJ_msg, "*");
	}

	save(OBJ_newsletter){

		this.isSaving = true;

		let  OBJ_result = null;
		OBJ_result = this.OBJ_detail_service.put(
			this.OBJ_detail_service.OBJ_detail_content.getLinkToSelf(),
			OBJ_newsletter
		)
	//	console.log(OBJ_newsletter);

		OBJ_result.subscribe((OBJ_response)=>{
				// console log
				this.OBJ_helper_service.log
				(
					{class: 'DetailComponent', function: 'save'},
					"Response after save:",
					OBJ_response
				);

				this.OBJ_toastr_service.success(this.OBJ_translate_service.instant("saved_successfully"));


				this.OBJ_newsletter = OBJ_response;

				this.saveNewsletterSuccess();

				//this.OBJ_detail_service.clearForm();
				//this.getFormControl().markAsUntouched();
				//this.getFormControl().markAsPristine();



			},(OBJ_error)=>{
				this.OBJ_helper_service.log
				(
					{class: 'DetailComponent', function: 'update'},
					"Error",
					OBJ_error
				);
				this.showError(OBJ_error);

				this.saveNewsletterFinish();
			},
			()=>{

				this.isSaving = false;
				// Ladeanimation aus

			});
	}

	public saveNewsletterFinish()
	{
		let iframeEl = document.getElementById(FormNewslettercontentsComponent.IFRAME_ID) as HTMLIFrameElement;
		let OBJ_msg =
			{
				"event": "save_finish"
			};
		this.isSaving = false;
		//this.OBJ_model_iframe.nativeElement.contentWindow.postMessage(OBJ_msg,"*")
		iframeEl.contentWindow.postMessage(OBJ_msg, "*");
	}

	/**
	 * Function > showError
	 *
	 * @desc Gebe Nutzer Feedback ueber Fehler
	 * @param OBJ_error
	 */
	showError(OBJ_error)
	{

		if (OBJ_error.status == 0)
		{
			// output error
			this.OBJ_toastr_service.error(this.OBJ_translate_service.instant("error_default"));
		}
		else if (typeof OBJ_error.error.cst_type != "undefined")
		{
			// output error
			this.OBJ_toastr_service.error(this.OBJ_translate_service.instant(OBJ_error.error.cst_type.toLowerCase()));
		}
		else if (OBJ_error.error.error)
		{
			// output error
			this.OBJ_toastr_service.error(OBJ_error.error.error.message);
		}
		else
		{
			// output error
			this.OBJ_toastr_service.error(OBJ_error.error.detail);
		} // end if

	} // end function showError

	/**
	 * Function > saveIframe
	 *
	 * @desc sendet save-event an iFrame, der wenn er bereit ist, in config-event Daten per Eevnt zurueckschickt
	 */
	getPreview()
	{
		let params = this.OBJ_route.params;
		// Fetch Formbuilder iFrame
		let iframeEl = document.getElementById(FormNewslettercontentsComponent.IFRAME_ID) as HTMLIFrameElement;
		const url = "https://newsletter.vogel.de/" + this.OBJ_helper_service.getFromLocalstorage('client').language + "/infinity/" + params['_value'].id + "/html/0/?preview=1&notsave";
		window.open(url, '_blank');

	} // end function getPreview

	async delay(ms: number) {
		await new Promise(resolve => setTimeout(()=>resolve(0), ms)).then(()=>console.log("fired"));
	}

	getPreviewAndSave()
	{
		this.saveIframe();
		let params = this.OBJ_route.params;
		// Fetch Formbuilder iFrame
		let iframeEl = document.getElementById(FormNewslettercontentsComponent.IFRAME_ID) as HTMLIFrameElement;
		const url = "https://newsletter.vogel.de/" + this.OBJ_helper_service.getFromLocalstorage('client').language + "/infinity/" + params['_value'].id + "/html/0/?preview=1&save=1";
		window.open(url, '_blank');

	} // end function getPreviewandSave

	/**
	 * Function > saveIframe
	 *
	 * @desc sendet save-event an iFrame, der wenn er bereit ist, in config-event Daten per Eevnt zurueckschickt
	 */
	saveIframe()
	{
		// Fetch Formbuilder iFrame
		let iframeEl = document.getElementById(FormNewslettercontentsComponent.IFRAME_ID) as HTMLIFrameElement;

		// Request data from iFrame
		let OBJ_msg =
			{
				"event": "save",
				"data": {}
			};

		// send message to iFrame that we want its data
		iframeEl.contentWindow.postMessage(OBJ_msg, "*");
	} // end function saveIframe

	/**
	 * Function > closeIframeAndSave
	 *
	 * @desc sendet save-event an iFrame, der wenn er bereit ist, in config-event Daten per Eevnt zurueckschickt
	 */
	closeIframeAndSave()
	{
		// Fetch Formbuilder iFrame
		let iframeEl = document.getElementById(FormNewslettercontentsComponent.IFRAME_ID) as HTMLIFrameElement;

		// Request data from iFrame
		let OBJ_msg =
			{
				"event": "saveandclose",
				"data": {}
			};
		// send message to iFrame that we want its data
		iframeEl.contentWindow.postMessage(OBJ_msg, "*");
		this.OBJ_iframe_ref.hide();
	} // end function closeIframeAndSave

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormNewslettercontentsComponent.IFRAME_ID;
	} // end function getIFrameID


} // end class FormNewslettercontentsComponent
